// This file is part of Moodle - http://moodle.org/
//
// Moodle is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// Moodle is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with Moodle.  If not, see <http://www.gnu.org/licenses/>.

/**
 * Selectors used for ARIA.
 *
 * @module     core/local/aria/selectors
 * @copyright  2020 Andrew Nicols <andrew@nicols.co.uk>
 * @license    http://www.gnu.org/copyleft/gpl.html GNU GPL v3 or later
 */
export default {
    aria: {
        hidden: '[aria-hidden]',
    },
    elements: {
        focusable: 'input:not([type="hidden"]):not([disabled]):not([tabindex^="-"]),' +
            'a[href]:not([disabled]):not([tabindex^="-"]),' +
            'button:not([disabled]):not([tabindex^="-"]),' +
            'textarea:not([disabled]):not([tabindex^="-"]),' +
            'select:not([disabled]):not([tabindex^="-"]),' +
            '[tabindex]:not([disabled]):not([tabindex^="-"])',
        focusableToUnhide: '[data-aria-hidden-tab-index]',
    },
};
